export { outlineCardsExtensions } from "./outlineCards";
export { numberedStepsExtensions } from "./numberedSteps";
export { imageGridExtensions } from "./imageGrid";
export { insertBlock, buildBlockContent } from "./insertHelpers";

import { outlineCardsExtensions } from "./outlineCards";
import { numberedStepsExtensions } from "./numberedSteps";
import { imageGridExtensions } from "./imageGrid";

export const sceneBlockExtensions = [
    ...outlineCardsExtensions,
    ...numberedStepsExtensions,
    ...imageGridExtensions,
];

/**
 * Names of every text-bearing block-field node across all custom blocks.
 * Sourced from `./registry.ts` — toolbar extensions (TextAlign, TextDirection)
 * read this to know which non-paragraph nodes can carry text. Adding a new
 * block to the registry automatically extends this list.
 */
export { SCENE_BLOCK_FIELD_NODE_NAMES as sceneBlockFieldNodeNames } from "./registry";

export type {
    SceneBlockData,
    SceneBlockType,
    ImageGridBlock,
    NumberedStepsBlock,
    OutlineCardsBlock,
} from "./types";

export {
    SCENE_BLOCK_REGISTRY,
    SCENE_BLOCK_TYPES,
    blockToHtml,
    type SceneBlockDescriptor,
    type SceneBlockItemPayload,
} from "./registry";
